/* jshint browserify: true */
'use strict';

import calendarSelectWidget from '../../../Widgets/ui/calendarSelect';

window._define('bridge/widgets/calendarSelect', function () {
  return calendarSelectWidget;
});
